import { z } from 'zod';
/**
 * Verificación pública de una factura por CSV (destino del QR impreso).
 *
 * El contrato es deliberadamente CORTO: aquí NO hay ni un solo campo del
 * destinatario. Si algún día hace falta añadir información, el criterio es
 * "¿lo necesita quien tiene la factura delante para comprobar que es
 * auténtica?" — y el nombre del cliente no lo necesita. Ver el porqué completo
 * en apps/api/src/routes/public-verification.ts.
 */
export const InvoiceVerificationSchema = z.object({
    found: z.boolean(),
    number: z.string().nullable().optional(),
    kind: z.string().nullable().optional(),
    status: z.string().nullable().optional(),
    issueDate: z.string().nullable().optional(),
    /** Razón social del EMISOR (persona jurídica), no del cliente. */
    issuerName: z.string().nullable().optional(),
    issuerNationalId: z.string().nullable().optional(),
    subtotalCents: z.number().int().optional(),
    vatCents: z.number().int().optional(),
    irpfCents: z.number().int().optional(),
    totalCents: z.number().int().optional(),
    csv: z.string().nullable().optional(),
    hash: z.string().nullable().optional(),
});
//# sourceMappingURL=verification.js.map